/* Wellbe bag — shared cart for index.html + backlux.html.
   Include with <script src="cart.js"></script> before </body>.
   Any element with data-cart-add + data-id/data-title/data-price/data-img
   (optional data-qty, data-deal='{"2":119.97,"3":180}') adds to the bag.
   Checkout builds one Shopify cart permalink.
   Cross-sells (Oct 2026): a single Necklux, Backlux or HyPRO in the bag gets an
   "add X & get Y FREE" offer. Accepting swaps that unit for the matching
   Shopify bundle (Necklux Kit / Backlux Kit / HyPRO Kit) so the free gift is
   charged at $0. */
(function(){
  var KEY='wellbeCart_v1';
  var BASE='https://shopwellbethebrand.com/cart/';

  /* Meta Pixel: safe wrapper (no-op if the pixel is blocked or not yet loaded) */
  function track(ev,data){try{if(typeof fbq==='function')fbq('track',ev,data);}catch(e){}}

  function load(){try{var v=JSON.parse(localStorage.getItem(KEY));return Array.isArray(v)?v:[]}catch(e){return[]}}
  function save(){try{localStorage.setItem(KEY,JSON.stringify(items))}catch(e){}}
  var items=load();

  /* ---------- styles ---------- */
  var css=''+
  '.bagbtn{position:relative;width:46px;height:46px;border-radius:50%;display:grid;place-items:center;background:var(--mint);color:var(--ink);transition:background .2s ease,transform .2s ease;flex:0 0 auto;margin-left:12px}'+
  '.bagbtn:hover{background:#d3ebe5;transform:translateY(-2px)}'+
  '.bagbtn svg{width:21px;height:21px}'+
  '.bagct{position:absolute;top:-4px;right:-4px;min-width:20px;height:20px;padding:0 5px;border-radius:999px;background:var(--coral);color:#fff;font:800 12px/20px var(--body);text-align:center;box-shadow:0 4px 10px rgba(244,99,78,.45);display:none}'+
  '.bagct.show{display:block}'+
  '.bag-ov{position:fixed;inset:0;background:rgba(14,43,51,.45);z-index:90;opacity:0;pointer-events:none;transition:opacity .35s ease}'+
  '.bag-ov.show{opacity:1;pointer-events:auto}'+
  '.bag-dr{position:fixed;top:0;right:0;bottom:0;width:min(430px,94vw);background:#fff;z-index:95;display:flex;flex-direction:column;border-radius:26px 0 0 26px;box-shadow:-20px 0 60px rgba(14,43,51,.25);transform:translateX(105%);transition:transform .45s cubic-bezier(.2,.8,.3,1)}'+
  '.bag-dr.show{transform:none}'+
  '.bag-hd{display:flex;align-items:center;justify-content:space-between;padding:20px 22px 14px}'+
  '.bag-hd h3{font-family:var(--disp);font-weight:800;font-size:23px}'+
  '.bag-x{width:38px;height:38px;border-radius:50%;background:var(--mint);display:grid;place-items:center;transition:background .2s ease,transform .2s ease}'+
  '.bag-x:hover{background:#d3ebe5;transform:rotate(90deg)}'+
  '.bag-x svg{width:15px;height:15px}'+
  '.bag-strip{background:#bfe4ea;color:var(--ink);font-weight:800;font-size:12.5px;letter-spacing:.08em;text-transform:uppercase;text-align:center;padding:8px 14px}'+
  '.bag-list{flex:1;overflow-y:auto;padding:8px 22px}'+
  '.bag-it{display:grid;grid-template-columns:64px 1fr auto;gap:14px;align-items:center;padding:16px 0;border-bottom:1.5px solid var(--line)}'+
  '.bag-it:last-child{border-bottom:0}'+
  '.bag-im{width:64px;height:64px;border-radius:14px;object-fit:cover;background:#f0f2f0}'+
  '.bag-tt{font-family:var(--disp);font-weight:700;font-size:16px;line-height:1.25}'+
  '.bag-un{font-size:13px;font-weight:700;color:var(--ink-dim);margin-top:2px}'+
  '.bag-deal{display:inline-block;font-size:11.5px;font-weight:800;color:var(--teal-deep);background:var(--mint);border-radius:999px;padding:2px 9px;margin-top:5px}'+
  '.bag-qty{display:inline-flex;align-items:center;gap:10px;margin-top:8px;background:var(--mint);border-radius:999px;padding:5px 8px}'+
  '.bag-qty button{width:24px;height:24px;border-radius:50%;background:#fff;font:800 15px/1 var(--body);display:grid;place-items:center;transition:background .15s ease}'+
  '.bag-qty button:hover{background:var(--teal);color:#fff}'+
  '.bag-qty b{font:800 14px/1 var(--body);min-width:16px;text-align:center}'+
  '.bag-ln{font-family:var(--disp);font-weight:800;font-size:17px;text-align:right}'+
  '.bag-rm{display:block;margin:6px 0 0 auto;font-size:11.5px;font-weight:800;color:var(--ink-dim);text-decoration:underline;text-underline-offset:2px}'+
  '.bag-rm:hover{color:var(--coral)}'+
  '.bag-empty{text-align:center;padding:70px 20px;color:var(--ink-dim);font-weight:700}'+
  '.bag-empty svg{width:52px;height:52px;margin:0 auto 14px;color:var(--teal);display:block}'+
  '.bag-empty a{display:inline-block;margin-top:16px;color:var(--teal-deep);font-weight:800;border-bottom:2.5px solid var(--teal)}'+
  '.bag-ft{padding:16px 22px 20px;border-top:1.5px solid var(--line);background:#fff;border-radius:0 0 0 26px}'+
  '.bag-sub{display:flex;justify-content:space-between;align-items:baseline;font-family:var(--disp);font-weight:800;font-size:20px;margin-bottom:4px}'+
  '.bag-note{font-size:12px;font-weight:700;color:var(--ink-dim);margin-bottom:14px}'+
  '.bag-co{display:flex;width:100%;align-items:center;justify-content:center;gap:10px;font-family:var(--disp);font-weight:700;font-size:19px;letter-spacing:.06em;padding:18px 20px;border-radius:999px;background:var(--coral);color:#fff;box-shadow:0 12px 26px rgba(244,99,78,.4);transition:background .2s ease,transform .2s ease}'+
  '.bag-co:hover{background:#e04c38;transform:translateY(-2px)}'+
  '.bag-co svg{width:16px;height:16px}'+
  '.bag-micro{text-align:center;font-size:12px;font-weight:700;color:var(--ink-dim);margin-top:10px}'+
  '.bag-up{display:grid;grid-template-columns:48px 1fr auto;gap:12px;align-items:center;background:var(--mint);border-radius:16px;padding:10px 12px;margin:10px 0 4px}'+
  '.bag-up img{width:48px;height:48px;border-radius:12px;object-fit:cover}'+
  '.bag-inc{font-size:12px;font-weight:700;color:var(--ink-dim);line-height:1.35;margin-top:3px}'+
  '.bag-rec-hd{font-family:var(--disp);font-weight:800;font-size:15px;margin:14px 0 2px}'+
  '.bag-up .t{font-weight:800;font-size:13.5px;line-height:1.3}'+
  '.bag-up .t small{display:block;font-weight:700;color:var(--ink-dim);font-size:12px}'+
  '.bag-up button{background:var(--teal);color:#fff;font:700 13.5px/1 var(--disp);padding:10px 18px;border-radius:999px;transition:background .2s ease,transform .2s ease}'+
  '.xs{border:2.5px solid var(--teal);background:#f6fcfc;border-radius:18px;padding:14px;margin:12px 0 6px;box-shadow:0 10px 24px rgba(18,160,180,.14)}'+
  '.xs-hd{font-family:var(--disp);font-weight:800;font-size:17px;margin-bottom:8px}'+
  '.xs-it{display:flex;align-items:center;gap:9px;font-size:14px;font-weight:700;margin-top:6px}'+
  '.xs-it img{width:38px;height:38px;border-radius:10px;object-fit:cover;flex:0 0 38px;background:var(--mint)}'+
  '.xs-n{flex:1;min-width:0}'+
  '.xs-p{white-space:nowrap;font-family:var(--disp);font-weight:800;font-size:15px}'+
  '.xs-p s{font-family:var(--body);font-weight:700;font-size:13px;color:var(--ink-dim);opacity:.8;margin-right:7px}'+
  '.xs-p b{color:var(--coral);letter-spacing:.04em}'+
  '.xs-gifts{margin-top:10px;padding:9px 10px 10px;border:2px dashed var(--coral);border-radius:14px;background:#fff6f4}'+
  '.xs-gh{font-family:var(--disp);font-weight:800;font-size:11px;letter-spacing:.1em;color:var(--coral)}'+
  '.xs-gv{margin-top:9px;display:flex;justify-content:space-between;align-items:center;background:var(--coral);color:#fff;font-family:var(--disp);font-weight:800;font-size:14px;padding:8px 12px;border-radius:12px}'+
  '.xs-gv b{display:inline-block;font-size:18px;background:var(--sun);color:var(--ink);padding:1px 10px;border-radius:999px;transform:rotate(-2deg)}'+
  '.xs-btn{display:block;width:100%;margin-top:10px;background:var(--teal-deep);color:#fff;font:700 16px/1 var(--disp);letter-spacing:.05em;padding:14px;border-radius:999px;box-shadow:0 10px 22px rgba(11,125,141,.35);transition:background .2s ease,transform .2s ease}'+
  '.xs-btn:hover{background:#086875;transform:translateY(-1px)}'+
  '.bag-up button:hover{background:var(--teal-deep);transform:translateY(-1px)}'+
  '.wa-fab{position:fixed;left:16px;bottom:16px;z-index:65;width:54px;height:54px;border-radius:50%;background:#25D366;color:#fff;display:grid;place-items:center;box-shadow:0 12px 28px rgba(37,211,102,.45);transition:transform .2s ease}'+
  '.wa-fab:hover{transform:scale(1.08)}'+
  '.wa-fab svg{width:28px;height:28px}'+
  '.ham{display:none;width:42px;height:42px;border-radius:50%;background:var(--mint);place-items:center;flex:0 0 auto;margin-right:10px;transition:background .2s ease}'+
  '.ham:hover{background:#d3ebe5}'+
  '.ham svg{width:18px;height:18px}'+
  '.ham .ic-x{display:none}'+
  '.ham.open .ic-bars{display:none}'+
  '.ham.open .ic-x{display:block}'+
  '.mnav{position:absolute;top:100%;left:0;right:0;background:#fff;box-shadow:0 22px 34px rgba(14,43,51,.14);border-radius:0 0 24px 24px;padding:6px 22px 14px;display:none}'+
  '.mnav.open{display:block}'+
  '.mnav a{display:block;padding:14px 4px;font-family:var(--disp);font-weight:700;font-size:18px;border-bottom:1.5px solid var(--line)}'+
  '.mnav a:last-child{border-bottom:0;color:var(--teal-deep)}'+
  '@media (max-width:900px){.ham{display:grid}}'+
  '@media (max-width:640px){.nav-in>.btn{display:none}}'+
  '@media (max-width:640px){.bag-dr{border-radius:22px 0 0 22px}.bag-list{padding:6px 16px}.bag-hd,.bag-ft{padding-left:16px;padding-right:16px}.wa-fab{left:12px;bottom:82px;width:50px;height:50px}}'+
  '@media (max-width:640px),(max-height:760px){.bag-dr{overflow-y:auto;overscroll-behavior:contain}.bag-list{flex:none;overflow:visible}.bag-ft{margin-top:auto}.bag-hd{position:sticky;top:0;z-index:2;background:#fff;border-radius:inherit}}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);

  /* ---------- DOM ---------- */
  var bagSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1.2 12.2a1.8 1.8 0 01-1.8 1.8H8a1.8 1.8 0 01-1.8-1.8z"/><path d="M8.5 8V6.5a3.5 3.5 0 017 0V8"/></svg>';
  var xSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var arrSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  var navIn=document.querySelector('.nav-in');
  var bagBtn=document.createElement('button');
  bagBtn.className='bagbtn';bagBtn.setAttribute('aria-label','Open your bag');
  bagBtn.innerHTML=bagSvg+'<b class="bagct" id="bagCt"></b>';
  if(navIn)navIn.appendChild(bagBtn);

  var ov=document.createElement('div');ov.className='bag-ov';document.body.appendChild(ov);
  var dr=document.createElement('aside');dr.className='bag-dr';dr.setAttribute('role','dialog');dr.setAttribute('aria-label','Your bag');
  dr.innerHTML='<div class="bag-hd"><h3 id="bagTitle">Your bag</h3><button class="bag-x" aria-label="Close bag">'+xSvg+'</button></div>'+
    '<div class="bag-strip">Free delivery across Lebanon · Cash on delivery</div>'+
    '<div class="bag-list" id="bagList"></div>'+
    '<div class="bag-ft" id="bagFt"></div>';
  document.body.appendChild(dr);
  var list=dr.querySelector('#bagList'),ft=dr.querySelector('#bagFt'),title=dr.querySelector('#bagTitle'),ct=bagBtn.querySelector('#bagCt');

  /* floating WhatsApp bubble */
  var wa=document.createElement('a');
  wa.className='wa-fab';wa.href='https://wa.me/96176511048';wa.target='_blank';wa.rel='noopener';
  wa.setAttribute('aria-label','Chat with us on WhatsApp');
  wa.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 00-8.6 15.1L2 22l5-1.3A10 10 0 1012 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .3-3.4-.7-2.9-1.2-4.7-4.1-4.9-4.3-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5s.8 1.9.8 2c.1.1.1.3 0 .5-.3.6-.7.9-.5 1.2.7 1.2 1.6 2 2.8 2.6.3.2.5.1.7-.1l.9-1c.2-.3.4-.2.7-.1l2 1c.3.1.5.2.5.3.1.1.1.6-.2 1.4z"/></svg>';
  document.body.appendChild(wa);

  var ALOE={id:'44005418664156',title:'Aloe Vera Gel',price:9.98,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/aloe.jpg?v=115743701757607329141788958123'};
  /* cross-sell offers: base product id -> bundle it upgrades into */
  var UPS={
    '46594057109724':{for:'Necklux 2.0',add:[{n:'Aloe Vera Gel',p:9.98,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/aloe.jpg?v=115743701757607329141788958123'}],gifts:[{n:'Anti-Shock Case',w:25,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/case.jpg?v=75005889302718494161788958125'}],
      kit:{id:'67640029872348',title:'Necklux 2.0 + Aloe Vera Gel + FREE Anti-Shock Case',price:69.95,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/necklux_product.jpg?v=80927132707445514381788958125'}},
    '45278628184284':{for:'Backlux',add:[{n:'Foot Stretcher',p:24.97,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/foot_stretcher.jpg?v=28626821067944356461788958123'}],gifts:[{n:'Aloe Vera Gel',w:15,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/aloe.jpg?v=115743701757607329141788958123'}],
      kit:{id:'67640069390556',title:'Backlux + Foot Stretcher + FREE Aloe Vera Gel',price:94.94,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/backlux_product.jpg?v=142593928816441006471788958126'}},
    '51928224137436':{for:'HyPRO',add:[{n:'Foot Stretcher',p:24.97,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/foot_stretcher.jpg?v=28626821067944356461788958123'}],gifts:[{n:'Extra Foot Stretcher',w:40,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/foot_stretcher.jpg?v=28626821067944356461788958123'},{n:'Pro Knee Strap ×2',w:50,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/knee_strap.jpg?v=184099110813778711351788958123'}],
      kit:{id:'67640054513884',title:'HyPRO + Foot Stretcher + FREE extra Foot Stretcher & 2 Knee Straps',price:124.94,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/hypro_product.jpg?v=129526025712389615121788958125'}}
  };

  /* Kits (Shopify Bundles): cart shows the kit's own name + photo, and what's inside.
     contains = component variant ids, used so the cart never recommends something already in a kit. */
  var NECK='46594057109724',BACK='45278628184284',HYPRO='51928224137436',
      ALOEID='44005418664156',CASE='44005420433628',FOOT='47889370415324',KNEE='51106135572700';
  var KITS={
    '67640029872348':{name:'Necklux Kit',img:'https://cdn.shopify.com/s/files/1/0650/4218/6460/files/necklux_kit.jpg?v=1791234458',
      inc:'Necklux 2.0, Aloe Vera Gel + FREE Anti-Shock Case',contains:[NECK,ALOEID,CASE]},
    '67640069390556':{name:'Backlux Kit',img:'https://cdn.shopify.com/s/files/1/0650/4218/6460/files/backlux_kit.jpg?v=1791234403',
      inc:'Backlux, Foot Stretcher + FREE Aloe Vera Gel',contains:[BACK,FOOT,ALOEID]},
    '67640072339676':{name:'Neck & Back Kit',img:'https://cdn.shopify.com/s/files/1/0650/4218/6460/files/neck_and_back_kit.jpg?v=1791234333',
      inc:'Necklux 2.0, Backlux + FREE Aloe Vera Gel, Anti-Shock Case & Knee Strap',contains:[NECK,BACK,ALOEID,CASE,KNEE]},
    '67640054513884':{name:'HyPRO Kit',img:'https://cdn.shopify.com/s/files/1/0650/4218/6460/files/hypro_kit_67d33d85-4b38-416a-9ff7-7af4a0137839.jpg?v=1791234551',
      inc:'HyPRO, Foot Stretcher + FREE extra Foot Stretcher & 2 Knee Straps',contains:[HYPRO,FOOT,KNEE]},
    '67600815456476':{name:'Total Body Kit',img:'https://cdn.shopify.com/s/files/1/0650/4218/6460/files/total_body_kit_f75dda70-eeac-416a-9224-10bf32671b8c.jpg?v=1791234517',
      inc:'Necklux 2.0, Backlux, HyPRO + FREE Aloe Vera Gel, Anti-Shock Case, Foot Stretcher & 2 Knee Straps',contains:[NECK,BACK,HYPRO,ALOEID,CASE,FOOT,KNEE]}
  };
  /* "People usually order this too": first item here that isn't already in the bag or inside a kit.
     needs = only show it if one of these is owned (the case only makes sense with a Necklux). */
  var REC=[
    {id:ALOEID,title:'Aloe Vera Gel',price:9.98,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/aloe.jpg?v=115743701757607329141788958123',why:'Preps the skin before every TENS session'},
    {id:CASE,title:'Anti-Shock Case',price:14.97,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/case.jpg?v=75005889302718494161788958125',why:'Protects your Necklux at work and on trips',needs:[NECK]},
    {id:FOOT,title:'The Ultimate Foot Stretcher',price:24.97,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/foot_stretcher.jpg?v=28626821067944356461788958123',why:'Releases tight calves and heels in minutes'},
    {id:KNEE,title:'The Pro Knee Strap',price:14.97,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/knee_strap.jpg?v=184099110813778711351788958123',why:'Support for walking, stairs and training'},
    {id:NECK,title:'Necklux 2.0 Neck Massager',price:59.97,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/necklux_product.jpg?v=80927132707445514381788958125',why:'Physio level neck relief at home'},
    {id:BACK,title:'Backlux™ Lower Back Massager',price:69.97,img:'//shopwellbethebrand.com/cdn/shop/t/19/assets/backlux_product.jpg?v=142593928816441006471788958126',why:'Relaxes a tight lower back after sitting'}
  ];
  function owned(){
    var o={};
    items.forEach(function(i){o[i.id]=1;if(KITS[i.id])KITS[i.id].contains.forEach(function(c){o[c]=1})});
    return o;
  }
  function pickRec(){
    var o=owned();
    for(var r=0;r<REC.length;r++){
      var x=REC[r];
      if(o[x.id])continue;
      if(x.needs&&!x.needs.some(function(n){return o[n]}))continue;
      return x;
    }
    return null;
  }

  /* mobile hamburger: mirrors this page's nav links into a dropdown */
  var links=document.querySelector('.nav-links');
  if(navIn&&links){
    var ham=document.createElement('button');
    ham.className='ham';ham.setAttribute('aria-label','Open menu');ham.setAttribute('aria-expanded','false');
    ham.innerHTML='<svg class="ic-bars" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg><svg class="ic-x" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    navIn.insertBefore(ham,navIn.firstChild);
    var mnav=document.createElement('nav');
    mnav.className='mnav';mnav.setAttribute('aria-label','Mobile menu');
    var mHtml=links.innerHTML;
    var navCta=navIn.querySelector(':scope > .btn');
    if(navCta)mHtml+='<a href="'+navCta.getAttribute('href')+'">'+navCta.textContent.trim()+'</a>';
    mnav.innerHTML=mHtml;
    document.querySelector('.nav').appendChild(mnav);
    function toggleMenu(force){
      var open=typeof force==='boolean'?force:!mnav.classList.contains('open');
      mnav.classList.toggle('open',open);
      ham.classList.toggle('open',open);
      ham.setAttribute('aria-expanded',open?'true':'false');
    }
    ham.addEventListener('click',function(){toggleMenu()});
    mnav.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('a'))toggleMenu(false)});
    window.__wellbeMenu=toggleMenu;
  }

  /* ---------- logic ---------- */
  function fmt(n){return '$'+(Math.round(n*100)/100).toFixed(2)}
  function count(){return items.reduce(function(s,i){return s+i.qty},0)}
  function lineTotal(it){
    if(it.deal&&it.deal[String(it.qty)])return it.deal[String(it.qty)];
    return it.price*it.qty;
  }
  function subtotal(){return items.reduce(function(s,i){return s+lineTotal(i)},0)}
  function maxQty(it){return it.deal?3:9}
  function checkoutHref(){
    if(!items.length)return '#';
    return BASE+items.map(function(i){return i.id+':'+i.qty}).join(',');
  }

  function render(){
    var n=count();
    ct.textContent=n>99?'99+':n;
    ct.classList.toggle('show',n>0);
    title.textContent=n>0?'Your bag ('+n+')':'Your bag';
    if(!items.length){
      list.innerHTML='<div class="bag-empty">'+bagSvg+'Your bag is empty.<br><a href="index.html#shop">Shop the best sellers</a></div>';
      ft.innerHTML='';
      return;
    }
    var h='';
    items.forEach(function(it,ix){
      var hasDeal=it.deal&&it.deal[String(it.qty)];
      var kit=KITS[it.id];
      h+='<div class="bag-it">'+
        '<img class="bag-im" src="'+(kit?kit.img:it.img)+'" alt="">'+
        '<div><div class="bag-tt">'+(kit?kit.name:it.title)+'</div>'+
        (kit?'<div class="bag-inc">Includes: '+kit.inc+'</div>':'')+
        '<div class="bag-un">'+fmt(it.price)+' each</div>'+
        (hasDeal?'<span class="bag-deal">Pack deal applied</span>':'')+
        '<span class="bag-qty"><button data-step="-1" data-ix="'+ix+'" aria-label="Less">−</button><b>'+it.qty+'</b><button data-step="1" data-ix="'+ix+'" aria-label="More">+</button></span></div>'+
        '<div><div class="bag-ln">'+fmt(lineTotal(it))+'</div>'+
        '<button class="bag-rm" data-rm="'+ix+'">Remove</button></div>'+
      '</div>';
    });
    var ups=items.filter(function(i){return UPS[i.id]});
    ups.forEach(function(i){
      var u=UPS[i.id],gv=u.gifts.reduce(function(t,g){return t+g.w},0),ap=u.add.reduce(function(t,x){return t+x.p},0);
      h+='<div class="xs"><div class="xs-hd">Complete your '+u.for+'</div>';
      u.add.forEach(function(x){h+='<div class="xs-it"><img src="'+x.img+'" alt=""><span class="xs-n">Add '+x.n+'</span><span class="xs-p">'+fmt(x.p)+'</span></div>'});
      h+='<div class="xs-gifts"><div class="xs-gh">YOUR FREE GIFT'+(u.gifts.length>1?'S':'')+'</div>';
      u.gifts.forEach(function(g){h+='<div class="xs-it"><img src="'+g.img+'" alt=""><span class="xs-n">'+g.n+'</span><span class="xs-p"><s>$'+g.w+'</s><b>FREE</b></span></div>'});
      h+='</div><div class="xs-gv">Gift Value: <b>$'+gv+'</b></div>'+
        '<button class="xs-btn" data-up-kit="'+i.id+'" type="button">ADD TO BAG · +'+fmt(ap)+'</button></div>';
    });

    var rec=ups.length?null:pickRec();
    if(rec){
      h+='<div class="bag-rec-hd">People usually order this too</div>'+
        '<div class="bag-up"><img src="'+rec.img+'" alt=""><span class="t">'+rec.title+'<small>'+rec.why+' · '+fmt(rec.price)+'</small></span><button data-up-rec="'+rec.id+'" type="button">Add</button></div>';
    }
    list.innerHTML=h;
    var anyDeal=items.some(function(i){return i.deal&&i.deal[String(i.qty)]});
    ft.innerHTML='<div class="bag-sub"><span>Subtotal</span><span>'+fmt(subtotal())+'</span></div>'+
      '<div class="bag-note">'+(anyDeal?'Pack discounts are applied automatically at checkout. ':'')+'Delivery is free. Pay cash at your door or with Whish.</div>'+
      '<a class="bag-co" href="'+checkoutHref()+'" target="_blank" rel="noopener">COMPLETE ORDER '+arrSvg+'</a>'+
      '<div class="bag-micro">Secure store checkout · 30 day returns · 1 year warranty</div>';
  }

  function open(){ov.classList.add('show');dr.classList.add('show');document.body.style.overflow='hidden'}
  function close(){ov.classList.remove('show');dr.classList.remove('show');document.body.style.overflow=''}

  function add(p){
    var found=null;
    for(var i=0;i<items.length;i++)if(items[i].id===p.id){found=items[i];break}
    if(found){found.qty=Math.min(found.qty+(p.qty||1),maxQty(found));if(p.deal)found.deal=p.deal}
    else{items.push({id:p.id,title:p.title,price:p.price,img:p.img,qty:Math.min(p.qty||1,p.deal?3:9),deal:p.deal||null})}
    save();render();open();
    var addQty=p.qty||1;
    track('AddToCart',{content_type:'product',content_ids:[p.id],content_name:p.title,contents:[{id:p.id,quantity:addQty}],value:(p.price||0)*addQty,currency:'USD'});
  }

  /* clicks */
  document.addEventListener('click',function(e){
    var t=e.target.closest?e.target.closest('[data-cart-add]'):null;
    if(t){
      e.preventDefault();
      var deal=null;
      if(t.getAttribute('data-deal')){try{deal=JSON.parse(t.getAttribute('data-deal'))}catch(err){}}
      add({id:t.getAttribute('data-id'),title:t.getAttribute('data-title'),price:parseFloat(t.getAttribute('data-price')),img:t.getAttribute('data-img'),qty:parseInt(t.getAttribute('data-qty')||'1',10),deal:deal});
      var old=t.innerHTML;
      t.innerHTML='ADDED ✓';
      setTimeout(function(){t.innerHTML=old},950);
      return;
    }
    /* checkout button in the drawer: fire InitiateCheckout, then let it navigate to Shopify */
    var co=e.target.closest?e.target.closest('.bag-co'):null;
    if(co&&items.length){
      track('InitiateCheckout',{content_type:'product',content_ids:items.map(function(i){return i.id}),contents:items.map(function(i){return {id:i.id,quantity:i.qty}}),num_items:count(),value:subtotal(),currency:'USD'});
      return;
    }
    var s=e.target.closest?e.target.closest('.bag-qty button'):null;
    if(s){
      var it=items[parseInt(s.getAttribute('data-ix'),10)];
      if(it){it.qty=Math.max(1,Math.min(it.qty+parseInt(s.getAttribute('data-step'),10),maxQty(it)));save();render()}
      return;
    }
    var r=e.target.closest?e.target.closest('.bag-rm'):null;
    if(r){items.splice(parseInt(r.getAttribute('data-rm'),10),1);save();render();return}
    var uk=e.target.closest?e.target.closest('[data-up-kit]'):null;
    if(uk){
      var bid=uk.getAttribute('data-up-kit'),u=UPS[bid];
      for(var k=0;k<items.length;k++)if(items[k].id===bid){items[k].qty--;if(items[k].qty<1)items.splice(k,1);break}
      add({id:u.kit.id,title:u.kit.title,price:u.kit.price,img:u.kit.img,qty:1});
      track('AddToCart',{content_type:'product',content_ids:[u.kit.id],content_name:'Cart cross-sell',value:u.add.reduce(function(t,x){return t+x.p},0),currency:'USD'});
      return;
    }
    var rc=e.target.closest?e.target.closest('[data-up-rec]'):null;
    if(rc){
      var rid=rc.getAttribute('data-up-rec');
      for(var q=0;q<REC.length;q++)if(REC[q].id===rid){add({id:REC[q].id,title:REC[q].title,price:REC[q].price,img:REC[q].img,qty:1});break}
      return;
    }
    if(e.target===ov){close();return}
    if(e.target.closest&&e.target.closest('.bag-x')){close();return}
    if(e.target.closest&&e.target.closest('.bagbtn')){render();open();return}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){close()}});
  window.addEventListener('storage',function(e){if(e.key===KEY){items=load();render()}});

  window.WellbeCart={add:add,open:function(){render();open()},count:count};
  render();
})();
